// Dedicated SEO landing pages — one per service.
// Each page has its own URL, title, meta description, H1, content sections,
// and is added to sitemap.xml + internally linked from /services.

import {
  Wind,
  Sparkles,
  Lightbulb,
  CircleDot,
  Feather,
} from "lucide-react";

export const SERVICE_PAGES = [
  {
    slug: "nettoyage-gouttieres-martinique",
    icon: Wind,
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/rsqacls6_C2363195-0B69-4A5B-9686-90E67343C2EA.png",
    imagePosition: "center 30%",
    seo: {
      title: "Nettoyage de gouttières en Martinique | SIGNA CLEAN",
      description:
        "SIGNA CLEAN réalise le nettoyage de gouttières en Martinique par aspiration, avec inspection possible et intervention adaptée aux maisons, bâtiments publics, écoles, syndics et entreprises.",
      keywords:
        "nettoyage gouttières Martinique, aspiration gouttières, débouchage gouttières Martinique, entretien gouttières Le Lamentin, gouttières écoles Martinique",
    },
    h1: "Nettoyage de gouttières en Martinique",
    intro:
      "SIGNA CLEAN intervient sur toute la Martinique pour le nettoyage professionnel de gouttières par aspiration haute portée. Une solution rapide, sécurisée et sans nacelle.",
    sections: [
      {
        title: "Notre méthode : aspiration haute portée",
        body:
          "Grâce à notre perche d'aspiration jusqu'à 12 mètres, nous nettoyons les gouttières sans nécessité de nacelle ni d'échafaudage. Le matériel professionnel utilisé permet d'éliminer feuilles, boues, racines et déchets accumulés en une seule intervention.",
      },
      {
        title: "Ce que nous proposons",
        bullets: [
          "Nettoyage de gouttières par aspiration",
          "Intervention sans nacelle lorsque possible",
          "Utilisation de matériel professionnel (perche & aspiration)",
          "Débouchage des gouttières et descentes",
          "Retrait des feuilles, boues, mousses et déchets",
          "Prévention des débordements et infiltrations",
        ],
      },
      {
        title: "Pour qui ?",
        body:
          "Notre prestation s'adresse aussi bien aux particuliers qu'aux syndics, écoles, collectivités et bâtiments professionnels en Martinique. Nous adaptons notre intervention à la configuration du site et à l'urgence.",
      },
    ],
    cta: "Demander un devis pour le nettoyage de gouttières",
    relatedSlugs: ["lessivage-sols-martinique", "photoluminescence-martinique"],
  },
  {
    slug: "lessivage-sols-martinique",
    icon: Sparkles,
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/lvnw8542_229692DC-6C6B-49E8-9D08-F797665A44A2.png",
    seo: {
      title: "Lessivage de sols en Martinique | Nettoyage haute pression SIGNA CLEAN",
      description:
        "SIGNA CLEAN propose le lessivage de sols extérieurs en Martinique avec nettoyeur haute pression et coupole de lavage pour parkings, drives, terrasses, allées et espaces professionnels.",
      keywords:
        "lessivage sols Martinique, nettoyage haute pression Martinique, coupole de lavage, nettoyage parking Martinique, nettoyage terrasse Le Lamentin",
    },
    h1: "Lessivage de sols en Martinique",
    intro:
      "Le lessivage de sols extérieurs par nettoyeur haute pression et coupole de lavage permet d'éliminer en profondeur traces, mousses et salissures incrustées. SIGNA CLEAN intervient partout en Martinique.",
    sections: [
      {
        title: "Notre matériel : haute pression + coupole de lavage",
        body:
          "Nous combinons un nettoyeur haute pression professionnel à une coupole de lavage rotative qui garantit un rendu uniforme, rapide et sans projection. Idéal pour les grandes surfaces et les sols délicats.",
      },
      {
        title: "Surfaces concernées",
        bullets: [
          "Parkings et drives professionnels",
          "Terrasses, allées et trottoirs",
          "Cours intérieures et patios",
          "Espaces de circulation en entreprise",
          "Sols extérieurs de restaurants et commerces",
        ],
      },
      {
        title: "Ce que nous éliminons",
        bullets: [
          "Salissures et traces noires",
          "Mousses, lichens et dépôts verts",
          "Pollutions urbaines et résidus de pneus",
          "Taches de graisse et hydrocarbures",
        ],
      },
      {
        title: "Pour qui ?",
        body:
          "Entreprises, restaurants, collectivités, syndics et particuliers martiniquais souhaitant redonner l'éclat d'origine à leurs sols extérieurs.",
      },
    ],
    cta: "Demander un devis pour un lessivage de sols",
    relatedSlugs: ["nettoyage-gouttieres-martinique", "plots-solaires-led-martinique"],
  },
  {
    slug: "plots-solaires-led-martinique",
    icon: CircleDot,
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/7gn7dlfs_0C398A45-FDFE-4683-802D-AEF0C51506D0.png",
    seo: {
      title: "Pose de plots solaires LED en Martinique | Sécurité voirie SIGNA CLEAN",
      description:
        "SIGNA CLEAN fournit et pose des plots solaires LED en Martinique pour améliorer la visibilité de nuit des passages piétons, parkings, allées, pontons et cheminements extérieurs.",
      keywords:
        "plots solaires LED Martinique, pose plots solaires, sécurité voirie Martinique, signalisation passage piéton, éclairage solaire autonome",
    },
    h1: "Pose de plots solaires LED en Martinique",
    intro:
      "Les plots solaires LED sont la solution idéale pour sécuriser les cheminements et voiries la nuit, sans aucun raccordement électrique. SIGNA CLEAN fournit et installe ces dispositifs partout en Martinique.",
    sections: [
      {
        title: "Une solution 100% autonome",
        body:
          "Chaque plot intègre un panneau solaire et une LED haute visibilité. Pendant la journée, le plot se recharge ; à la tombée de la nuit, il s'allume automatiquement pour signaler le cheminement. Aucune installation électrique nécessaire.",
      },
      {
        title: "Applications",
        bullets: [
          "Passages piétons et traversées de chaussée",
          "Parkings et places de stationnement",
          "Cheminements piétons et allées",
          "Passerelles, pontons et zones portuaires",
          "Zones touristiques et balisage de site",
        ],
      },
      {
        title: "Avantages",
        bullets: [
          "Visibilité nocturne renforcée",
          "0 consommation électrique",
          "Installation sans tranchée ni câblage",
          "Durabilité et résistance aux UV/intempéries",
          "Maintenance réduite",
        ],
      },
      {
        title: "Pour qui ?",
        body:
          "Mairies, collectivités, syndics, entreprises, zones touristiques et sites publics en Martinique souhaitant renforcer la sécurité de leurs usagers.",
      },
    ],
    cta: "Demander un devis pour des plots solaires LED",
    relatedSlugs: ["nez-de-marches-photoluminescents-martinique", "photoluminescence-martinique"],
  },
  {
    slug: "nez-de-marches-photoluminescents-martinique",
    icon: Lightbulb,
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/c5hu83hl_IMG_9259.jpeg",
    seo: {
      title: "Nez de marches photoluminescents en Martinique | SIGNA CLEAN",
      description:
        "SIGNA CLEAN installe des nez de marches photoluminescents en Martinique pour sécuriser les escaliers, ERP, bâtiments publics, parkings et cheminements en cas de faible luminosité.",
      keywords:
        "nez de marches photoluminescents Martinique, sécurisation escalier ERP, signalisation évacuation Martinique, photoluminescent escaliers, bandes photoluminescentes",
    },
    h1: "Nez de marches photoluminescents en Martinique",
    intro:
      "Les nez de marches photoluminescents assurent une visibilité claire des escaliers dans l'obscurité ou en cas de coupure électrique, sans aucune alimentation. Une solution conforme aux normes ERP, posée partout en Martinique par SIGNA CLEAN.",
    sections: [
      {
        title: "Notre prestation",
        bullets: [
          "Pose de nez de marches photoluminescents",
          "Sécurisation complète des escaliers",
          "Visibilité en cas de coupure de courant ou faible luminosité",
          "Préparation et nettoyage des supports avant pose",
          "Conseils sur le respect des normes ERP",
        ],
      },
      {
        title: "Où installer ?",
        bullets: [
          "Établissements recevant du public (ERP)",
          "Bâtiments publics et administrations",
          "Écoles, lycées, internats",
          "Parkings souterrains et cages d'escalier",
          "Résidences, immeubles, syndics",
          "Hôtels, restaurants, locaux professionnels",
        ],
      },
      {
        title: "Amélioration de la sécurité",
        body:
          "En cas de chute de tension ou d'évacuation d'urgence, les bandes photoluminescentes restent visibles plusieurs heures grâce à l'énergie lumineuse emmagasinée pendant la journée. C'est un dispositif passif, sans entretien et sans consommation.",
      },
    ],
    cta: "Demander un devis pour des nez de marches",
    relatedSlugs: ["photoluminescence-martinique", "plots-solaires-led-martinique"],
  },
  {
    slug: "photoluminescence-martinique",
    icon: Feather,
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/re3ig8vw_D5DC790C-7773-4E42-9AFF-E8BDF7473DA0.PNG",
    seo: {
      title: "Produits photoluminescents en Martinique | Sécurité et signalisation SIGNA CLEAN",
      description:
        "SIGNA CLEAN propose des solutions photoluminescentes en Martinique pour améliorer la sécurité des bâtiments, escaliers, cheminements, parkings et établissements recevant du public.",
      keywords:
        "photoluminescent Martinique, signalisation photoluminescente, marqueurs L photoluminescents, bandes de guidage Martinique, sécurité ERP photoluminescent",
    },
    h1: "Produits photoluminescents en Martinique",
    intro:
      "Marqueurs en L, bandes de guidage, nez de marches : SIGNA CLEAN déploie une gamme complète de produits photoluminescents pour signaler, guider et sécuriser sans aucune électricité.",
    sections: [
      {
        title: "Notre gamme photoluminescente",
        bullets: [
          "Marqueurs en L photoluminescents",
          "Bandes de guidage au sol et murales",
          "Nez de marches photoluminescents",
          "Pictogrammes d'évacuation et de sécurité",
          "Plaques d'identification haute visibilité",
        ],
      },
      {
        title: "Pourquoi adopter le photoluminescent ?",
        bullets: [
          "Sécurité en cas de coupure de courant",
          "Visibilité naturelle dans l'obscurité",
          "Conformité avec les obligations ERP",
          "0 consommation électrique",
          "Aucune maintenance ni recharge",
        ],
      },
      {
        title: "Pour qui ?",
        body:
          "Établissements recevant du public, collectivités, mairies, syndics, écoles, hôtels et entreprises en Martinique recherchant une signalétique de sécurité durable et conforme.",
      },
    ],
    cta: "Demander un devis pour des produits photoluminescents",
    relatedSlugs: ["nez-de-marches-photoluminescents-martinique", "plots-solaires-led-martinique"],
  },
  {
    slug: "depoussierage-hauteur-martinique",
    icon: Feather,
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/4u0hfnic_IMG_2377.jpeg",
    imagePosition: "center 30%",
    seo: {
      title: "Dépoussiérage en hauteur en Martinique | SIGNA CLEAN",
      description:
        "SIGNA CLEAN réalise le dépoussiérage en hauteur en Martinique : charpentes métalliques, gaines de ventilation, luminaires industriels, plafonds hauts et structures suspendues. Intervention sans nacelle avec aspiration professionnelle.",
      keywords:
        "dépoussiérage en hauteur Martinique, nettoyage charpente métallique Martinique, dépoussiérage gaines ventilation, nettoyage luminaires industriels Martinique, nettoyage plafond haut Martinique, aspiration industrielle 972",
    },
    h1: "Dépoussiérage en hauteur en Martinique",
    intro:
      "SIGNA CLEAN intervient en Martinique pour le dépoussiérage en hauteur des charpentes, plafonds, gaines techniques et luminaires industriels. Une solution propre, rapide et sécurisée grâce à notre perche d'aspiration télescopique — sans nacelle et sans démontage.",
    sections: [
      {
        title: "Notre méthode : aspiration télescopique haute portée",
        body:
          "Nous utilisons une perche d'aspiration professionnelle équipée d'embouts spécifiques qui élimine la poussière, les toiles d'araignées et les dépôts sans projection ni démontage. L'aspiration directe garantit un environnement propre et limite la dispersion des particules — idéal en site occupé.",
      },
      {
        title: "Ce que nous dépoussiérons",
        bullets: [
          "Charpentes métalliques, IPN et poutres bois",
          "Gaines de ventilation, conduits et chemins de câbles",
          "Luminaires industriels, projecteurs et néons",
          "Plafonds hauts, plafonds techniques et faux-plafonds",
          "Structures suspendues, ponts roulants et passerelles",
          "Tuyauteries, vannes et installations techniques en hauteur",
        ],
      },
      {
        title: "Avantages",
        bullets: [
          "Intervention sans nacelle ni échafaudage",
          "Aucun démontage de luminaires ou d'équipements",
          "Aspiration directe, sans projection",
          "Rapidité d'exécution sur site occupé",
          "Amélioration de la qualité d'air intérieur",
          "Prévention des risques incendie liés à l'accumulation de poussière",
        ],
      },
      {
        title: "Pour qui ?",
        body:
          "Entrepôts, ateliers industriels, salles de production, hangars, supermarchés, écoles, gymnases, ERP, hôtels et bâtiments tertiaires en Martinique souhaitant maintenir leurs installations propres, conformes et sécurisées.",
      },
    ],
    cta: "Demander un devis pour un dépoussiérage en hauteur",
    relatedSlugs: ["nettoyage-gouttieres-martinique", "lessivage-sols-martinique"],
  },
];
